import {
  PAYOUT_INITIATE_REQUEST,
  PAYOUT_INITIATE_SUCCESS,
  PAYOUT_INITIATE_FAIL,
  PAYOUT_INITIATE_RESET,
  CHECK_PAYOUT_STATUS_REQUEST,
  CHECK_PAYOUT_STATUS_SUCCESS,
  CHECK_PAYOUT_STATUS_FAIL,
} from '../actions/types';

// Reducer for the INITIATE payout action
export const payoutReducer = (state = {}, action) => {
  switch (action.type) {
    case PAYOUT_INITIATE_REQUEST:
      return { loading: true };
    case PAYOUT_INITIATE_SUCCESS:
      return { loading: false, success: true, payout: action.payload };
    case PAYOUT_INITIATE_FAIL:
      return { loading: false, error: action.payload };
    case PAYOUT_INITIATE_RESET:
      return {};
    default:
      return state;
  }
};

// --- NEW REDUCER TO FIX THE ERROR ---
// Reducer for the CHECK payout STATUS action
export const payoutStatusReducer = (state = { status: null }, action) => {
    switch (action.type) {
        case CHECK_PAYOUT_STATUS_REQUEST:
            return { ...state, loading: true, error: null };
        case CHECK_PAYOUT_STATUS_SUCCESS:
            return { loading: false, status: action.payload, error: null };
        case CHECK_PAYOUT_STATUS_FAIL:
            return { loading: false, error: action.payload, status: null };
        default:
            return state;
    }
};